import { Controller } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import { Buttons, Bid, ChooseCountriesBtn } from 'components';
import { CountryItem } from '../countryItem/CountryItem';
import { minServingFields } from 'constants';
import { ErrorIcon } from 'assets/icons';
import { limitDecimal, formatOnBlur } from 'utils';
import { validateCPI } from '../../validation';
import * as S from '../../MinimumServingForm.styled';

const fieldName = minServingFields.directBuy.field;

const DirectBuyCampaigns = ({
  appExclusionsDetails,
  directBuyCampaignsCountries,
  handleClearCountries,
  saveButtonDirectBuyCampaigns,
  control,
  errors,
  clearErrors,
  handleDeleteCountry,
  setValue,
}) => {
  return (
    <>
      <S.Head>Minimum CPI for Direct-Buy Campaigns</S.Head>
      <S.Field>
        <S.Title>Minimum Bid:</S.Title>
        <S.FieldsWrap>
          <Controller
            defaultValue={appExclusionsDetails?.minCpi}
            name={`${fieldName}.minCpi`}
            control={control}
            rules={validateCPI}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <S.InputWrap>
                <Bid.Big
                  label='CPI'
                  value={value}
                  error={!!error}
                  onChange={(e) => limitDecimal(e, onChange, 2)}
                  onBlur={() => formatOnBlur(value, onChange)}
                />
                {!!error && (
                  <S.ErrorWrap>
                    <ErrorIcon />
                    {error?.message}
                  </S.ErrorWrap>
                )}
              </S.InputWrap>
            )}
          />
        </S.FieldsWrap>
      </S.Field>
      <S.Field>
        <S.Title>Per Countries:</S.Title>
        <S.FieldsWrap>
          <S.ActionField>
            <ChooseCountriesBtn
              selectedCountries={directBuyCampaignsCountries}
              title='Included Countries'
              saveButtonAction={saveButtonDirectBuyCampaigns}
            />
            {directBuyCampaignsCountries?.length > 0 && (
              <>
                <Divider />
                <Buttons.TertiaryNormal
                  id='DirectBuyCampaignsClearAllBtn'
                  onClick={() => handleClearCountries(fieldName)}
                >
                  Clear All
                </Buttons.TertiaryNormal>
                {directBuyCampaignsCountries?.map((country, ind) => (
                  <CountryItem
                    key={country.cca2}
                    country={country}
                    control={control}
                    setValue={setValue}
                    index={ind}
                    field={fieldName}
                    errors={errors}
                    clearErrors={clearErrors}
                    handleDeleteCountry={handleDeleteCountry}
                  />
                ))}
              </>
            )}
          </S.ActionField>
        </S.FieldsWrap>
      </S.Field>
    </>
  );
};

export default DirectBuyCampaigns;
